import escapeRegExp from "lodash/escapeRegExp";

import { languages } from "../pages/trivia/languages";

// The two fixed sentences our outbound SMS adds, in every language. Copy comes
// from languages.js (mirrors backend/utils/trivvySmsCopy.js; keep in sync).
const BOILERPLATE_KEYS = ["userContentWarning", "optOut"];

const collectSentences = () => {
  const sentences = [];
  Object.keys(languages).forEach((code) => {
    BOILERPLATE_KEYS.forEach((key) => {
      const sentence = languages[code][key];
      if (typeof sentence !== "string") {
        return;
      }
      const trimmed = sentence.trim();
      if (trimmed && sentences.indexOf(trimmed) === -1) {
        sentences.push(trimmed);
      }
    });
  });
  return sentences;
};

const buildBoilerplatePattern = () => {
  const alternatives = collectSentences()
    .sort((a, b) => b.length - a.length)
    .map((sentence) => "\\s*" + escapeRegExp(sentence).replace(/\s+/g, "\\s+"));
  return new RegExp(alternatives.join("|"), "gi");
};

const BOILERPLATE_PATTERN = buildBoilerplatePattern();

// Read-time only: stored text stays raw. Never returns a blank string for a
// non-blank input, and returns non-strings untouched.
export const stripSmsBoilerplate = (text) => {
  if (typeof text !== "string" || text === "") {
    return text;
  }
  const stripped = text.replace(BOILERPLATE_PATTERN, "");
  if (stripped === text || stripped.trim() === "") {
    return text;
  }
  return stripped;
};
